import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./ChurnCaseStudy.scss";
import MegaHeader from "../MegaHeader";
import { imageUrl } from "../../utils/imagePath";

const ChurnCaseStudy = () => {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      <MegaHeader />
      <div className="strategy-containerChurn" style={{ backgroundImage: `url(${imageUrl("common", "ChurnInner.png")})` }}>
        <div className="strategy-text-Ocr">
          <h1 className="churn">Churn Prediction Analytics</h1>
          <br />
          <h1 className="churn-sub">Enhancing Subscriber Retention with Data-Driven Insights </h1>
        </div>
      </div>

      <div className="row mt-7 px">
        <div className="d-flex">
          <img src={imageUrl("common", "fullscreen.png")} className="mb-2 fullscreen" alt="full-screen" height={20} width={20}
            onClick={handleShow}
          ></img>

        </div>

        <div className="col-lg-12 col-md-12">
          <img src={imageUrl("churn", "ChurnDashboard.png")} alt="c" style={{ width: "100%" }}></img>
        </div>
      </div>

      {/* Modal for Streamlit App */}
      <Modal show={showModal} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton className="modal-header">
          <Modal.Title>Churn Prediction Analytics</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={imageUrl("churn", "ChurnDashboard.png")} alt="c" style={{ width: "100%" }}></img>
        </Modal.Body>
      </Modal>

      {/* Steps involved */}
      <div className="row px mt-7">
        <div className="col-4 " style={{ display: "flex" }}>
          <img src={imageUrl("churn", "Group 55.png")} alt="Ai" height={40} width={40}></img>
          <p className="icon-p">
            Leverages machine learning to predict customer churn, enabling proactive engagement with at-risk subscribers
          </p>
        </div>

        <div className="col-4 " style={{ display: "flex" }}>
          <img src={imageUrl("churn", "Group 50.png")} alt="Ai" height={40} width={40}></img>
          <p className="icon-p">
          Analyzes customer behavior and transaction history to identify patterns leading to churn. 
          </p>
        </div>

        <div className="col-4" style={{ display: "flex" }}>
          <img src={imageUrl("churn", "Group 51.png")} alt="Ai" height={40} width={40}></img>
          <p className="icon-p">
          Provides risk segmentation and personalized intervention strategies to retain customers and boost lifetime value.
          </p>
        </div>
      </div>

      <div className="row px mt-7">
        <div className="col-7">
          <h1 className="industry">Future</h1>
          <p className="application">Applications</p>
          <img src={imageUrl("churn", "c2.jpeg")} alt="train" className="w-100"></img>
          <p className="mt-4 normal-22">
            <strong>Revolutionizing Customer Engagement</strong> - Imagine a future where businesses can predict and prevent customer churn before it happens. Our AI-driven churn model empowers companies to deliver timely, personalized interventions, dramatically improving customer satisfaction and retention.
          </p>
          <p className="normal-22">
            <strong>Maximizing Retention Potential</strong> - Picture a system that not only identifies at-risk customers but also suggests the best course of action for each individual. With our predictive analytics, companies can optimize retention strategies, significantly lowering customer acquisition costs while increasing customer lifetime value
          </p>
          <p className="normal-22">
            <strong>Pioneering the Future of Predictive Analytics</strong> -
            Envision a future where real-time churn prediction is seamlessly integrated across all business systems. From marketing automation to customer service, experience a unified approach to retention that transforms churn into growth opportunities.
          </p>
        </div>

        <div className="col-5">
<img src={imageUrl("churn", "c4.webp")} alt="ny" className="py-2 w-100"></img>
            <img src={imageUrl("churn", "c5.webp")} alt="nurse" className="py-2 w-100"></img>
            <img src={imageUrl("churn", "GenAi4.png")} alt="bus" className="py-2 w-100"></img>
        </div>
      </div>
    </>
  );
};

export default ChurnCaseStudy;
